import React, { useEffect } from "react";
import QuestFour from "../../components/quote-components/quoteQuestions/QuestFour";
import { useNavContext } from "../../context-api/nav-context";

const QuestionFour = () => {
  const { closeNavbarMenu } = useNavContext();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <main onMouseOver={closeNavbarMenu}>
      <QuestFour />
    </main>
  );
};

export default QuestionFour;
